import { Box, Button, TextField, MenuItem, CircularProgress, InputAdornment, Typography, Dialog, IconButton } from "@mui/material";
import { Formik, useFormikContext } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import { useState, useEffect, useRef, useCallback } from "react";
import LoadingSpinner from "../../loadingSpinner";
import ModalSucces from "../../modal/modalSucces";
import ModalError from "../../modal/modalError";
import ModalCamion from "../../modal/camiones/modalCamion";
import { PostDatosVehiculo, getDinatran, getTruckImagen } from "../../services/vehiculos.services";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CloseIcon from "@mui/icons-material/Close";
import secureStorage from "../../utils/secureStorage";

const COUNTRY_OPTIONS = [
  { label: "Paraguay", value: "PY" },
  { label: "Brasil", value: "BR" },
];

const Vehiculo = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isModalCamionOpen, setIsModalCamionOpen] = useState(false);
  const [clasificacionModalOpen, setClasificacionModalOpen] = useState(false);
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [registrationError, setRegistrationError] = useState(false);
  const [error, setError] = useState("");
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const cod_empresa = secureStorage.getItem("cod_empresa");
  const [selectedCamion, setSelectedCamion] = useState({
    id: "",
    model: "",
    brand: "",
    chapa: "",
    chasis: "",
    year: "",
    axes: "",
    nroHabilitacion: "",
    propietario: "",
    ruc: "",
    situacion: "",
    vencimiento: "",
    capacidadCarga: "",
    peso: "",
  });
  const [isAutoLookupScheduled, setIsAutoLookupScheduled] = useState(false);
  const [isDinatranLoading, setIsDinatranLoading] = useState(false);
  const [vehiclePhotos, setVehiclePhotos] = useState([]);
  const [isPhotoPreviewOpen, setIsPhotoPreviewOpen] = useState(false);
  const [photoPreviewIndex, setPhotoPreviewIndex] = useState(0);
  const lastLookupRef = useRef({ chapa: "", country: "" });

  const handleConsultarDinatran = useCallback(async (values, setFieldValue) => {
    const chapaInput = values.chapa ? values.chapa.trim() : "";
    const normalizedChapa = chapaInput.toUpperCase();
    const selectedCountry = values.country;

    if (!normalizedChapa) {
      setError("Ingrese la chapa del vehículo antes de consultar.");
      setRegistrationError(true);
      return;
    }

    if (!selectedCountry) {
      setError("Seleccione el país de origen antes de consultar.");
      setRegistrationError(true);
      return;
    }

    lastLookupRef.current = { chapa: normalizedChapa, country: selectedCountry };
    setIsAutoLookupScheduled(false);
    setIsDinatranLoading(true);
    setVehiclePhotos([]);

    try {
      const response = await getDinatran(normalizedChapa, selectedCountry);
      let vehicleData = response?.data ?? response?.vehicle ?? response;

      if (Array.isArray(vehicleData)) {
        vehicleData = vehicleData[0];
      }

      if (!vehicleData) {
        setError("No se encontraron datos en Dinatran para la chapa ingresada.");
        setRegistrationError(true);
        return;
      }

      const resolvedChapa = vehicleData?.plate || vehicleData?.chapa || normalizedChapa;
      const resolvedBrand = vehicleData?.brand || vehicleData?.Marca || values.brand;
      const resolvedModel = vehicleData?.Tipo || vehicleData?.modelo || values.model;
      const chasisNumber = vehicleData?.chasis || vehicleData?.Chasis || vehicleData?.chassis || vehicleData?.Chassis || vehicleData?.vin || vehicleData?.VIN || "";
      const yearValue =
        vehicleData?.Anio ||
        vehicleData?.anioFabricacion ||
        "";
      const axesValue = vehicleData?.ejes || vehicleData?.Ejes || "";
      const nroHabilitacionValue =
        vehicleData?.NroHabilita ||
        "";
      const propietarioValue = vehicleData?.propietario || vehicleData?.Propietario || "";
      const rucValue = vehicleData?.ruc || vehicleData?.Ruc || vehicleData?.RUC || "";
      const situacionValue = vehicleData?.situacion || vehicleData?.Situacion || vehicleData?.resultado || "";
      const vencimientoValue =
        vehicleData?.Vencimiento ||
        vehicleData?.FechaVencimiento ||
        vehicleData?.vencimiento ||
        "";
      const capacidadCargaValue = vehicleData?.capacidadCarga || vehicleData?.CapacidadCarga || "";
      const pesoValue = vehicleData?.peso || vehicleData?.Peso || "";


      if (resolvedChapa) {
        const upperChapa = typeof resolvedChapa === "string" ? resolvedChapa.toUpperCase() : String(resolvedChapa).toUpperCase();
        setFieldValue("chapa", upperChapa);
        lastLookupRef.current = { chapa: upperChapa, country: selectedCountry };
      }

      if (resolvedBrand) {
        setFieldValue("brand", resolvedBrand);
      }

      if (resolvedModel) {
        setFieldValue("model", resolvedModel);
      }

      setFieldValue("chasis", chasisNumber || "");
      setFieldValue("year", yearValue || "");
      setFieldValue("axes", axesValue || "");
      setFieldValue("nroHabilitacion", nroHabilitacionValue || "");
      setFieldValue("propietario", propietarioValue || "");
      setFieldValue("ruc", rucValue || "");
      setFieldValue("situacion", situacionValue || "");
      setFieldValue("vencimiento", vencimientoValue || "");
      setFieldValue("capacidadCarga", capacidadCargaValue || "");
      setFieldValue("peso", pesoValue || "");

      let fotosList = Array.isArray(vehicleData?.fotos) ? vehicleData.fotos : [];

      if (!fotosList.length) {
        const inspections = Array.isArray(vehicleData?.Itv)
          ? vehicleData.Itv
          : Array.isArray(vehicleData?.itv)
            ? vehicleData.itv
            : [];

        const latestInspection = inspections.length
          ? inspections[inspections.length - 1]
          : null;

        if (
          latestInspection?.CodigoTaller &&
          latestInspection?.AraItv &&
          latestInspection?.NumeroPlanilla
        ) {
          const inspectionResponse = await getTruckImagen(
            latestInspection.CodigoTaller,
            latestInspection.AraItv,
            latestInspection.NumeroPlanilla
          );

          const inspectionPayload = inspectionResponse?.data ?? inspectionResponse;
          const inspectionFotos = Array.isArray(inspectionPayload?.fotos)
            ? inspectionPayload.fotos
            : Array.isArray(inspectionPayload?.data?.fotos)
              ? inspectionPayload.data.fotos
              : [];

          fotosList = inspectionFotos;
        }
      }

      setVehiclePhotos(Array.isArray(fotosList) ? fotosList.filter(Boolean) : []);
      setPhotoPreviewIndex(0);

      setSelectedCamion((prev) => ({
        ...prev,
        chapa: resolvedChapa ? String(resolvedChapa).toUpperCase() : "",
        brand: resolvedBrand || "",
        model: resolvedModel || "",
        chasis: chasisNumber || "",
        year: yearValue || "",
        axes: axesValue || "",
        nroHabilitacion: nroHabilitacionValue || "",
        propietario: propietarioValue || "",
        ruc: rucValue || "",
        situacion: situacionValue || "",
        vencimiento: vencimientoValue || "",
        capacidadCarga: capacidadCargaValue || "",
        peso: pesoValue || "",
      }));
    } catch (err) {
      setVehiclePhotos([]);
      setPhotoPreviewIndex(0);
      setError(err.message || "Error al consultar Dinatran.");
      setRegistrationError(true);
    } finally {
      setIsDinatranLoading(false);
    }
  }, [getDinatran, getTruckImagen]);

  const handleFormSubmit = async (values, { resetForm }) => {
    setIsLoading(true);

    const {
      brand,
      model,
      chapa,
      chasis,
      year,
      axes,
      nroHabilitacion,
      propietario,
      ruc,
      situacion,
      vencimiento,
      peso,
    } = values;

    const photosPayload = Array.isArray(vehiclePhotos)
      ? vehiclePhotos.filter(Boolean).join("|")
      : "";

    const valuesToSend = {
      brand,
      model,
      chapa,
      id_empresa: parseInt(cod_empresa),
      chasis,
      year,
      eje: axes,
      nro_habilitacion: nroHabilitacion,
      propietario,
      ruc_propietario: ruc,
      situacion,
      vencimiento: vencimiento,
      capacidad: peso,
      fotos: photosPayload, // Backend expects photo links concatenated with "|".
    };

    try {
      await new Promise((resolve) => setTimeout(resolve, 2000));
      console.log("🚀 ~ handleFormSubmit ~ valuesToSend:", valuesToSend)

      const resp = await PostDatosVehiculo(valuesToSend);
      setRegistrationSuccess(true);
      resetForm();
      setVehiclePhotos([]);
    } catch (error) {
      setRegistrationError(true);
      setError(error.message);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 3000);
    }
  };

  const handleCloseModal = () => {
    setRegistrationSuccess(false);
  };

  const handleCloseModalError = () => {
    setRegistrationError(false);
  };

  const handleSelectCamion = (camion) => {
    setSelectedCamion(camion);
  };

  const handleAutoSchedule = useCallback(() => setIsAutoLookupScheduled(true), []);
  const handleAutoCancel = useCallback(() => setIsAutoLookupScheduled(false), []);

  const handleOpenPhotoPreview = useCallback((index) => {
    setPhotoPreviewIndex(index);
    setIsPhotoPreviewOpen(true);
  }, []);

  const handleClosePhotoPreview = useCallback(() => {
    setIsPhotoPreviewOpen(false);
  }, []);

  const showPreviousPhoto = useCallback(() => {
    setPhotoPreviewIndex((prevIndex) => {
      if (!vehiclePhotos.length) return prevIndex;
      return (prevIndex - 1 + vehiclePhotos.length) % vehiclePhotos.length;
    });
  }, [vehiclePhotos.length]);

  const showNextPhoto = useCallback(() => {
    setPhotoPreviewIndex((prevIndex) => {
      if (!vehiclePhotos.length) return prevIndex;
      return (prevIndex + 1) % vehiclePhotos.length;
    });
  }, [vehiclePhotos.length]);

  useEffect(() => {
    if (!vehiclePhotos.length) {
      setIsPhotoPreviewOpen(false);
      setPhotoPreviewIndex(0);
    } else if (photoPreviewIndex >= vehiclePhotos.length) {
      setPhotoPreviewIndex(0);
    }
  }, [vehiclePhotos, photoPreviewIndex]);


  useEffect(() => {
    const handleKeyDown = (event) => {
      if (
        event.key === "F9" ||
        (event.key === "Tab" && document.activeElement.name === "id_level")
      ) {
        // setIsModalLevelOpen(true);
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <Box m="20px">
      <Header title="Registro Vehiculo" subtitle="Registro Vehiculo" />

      {isLoading && <LoadingSpinner />}
      {registrationSuccess && (
        <ModalSucces open={registrationSuccess} onClose={handleCloseModal} />
      )}
      {registrationError && (
        <ModalError
          open={registrationError}
          onClose={handleCloseModalError}
          error={error}
        />
      )}

      <Formik
        onSubmit={handleFormSubmit}
        initialValues={{
          brand: "",
          model: "",
          chapa: "",
          medidas: "",
          country: COUNTRY_OPTIONS[0].value,
          chasis: "",
          year: "",
          axes: "",
          nroHabilitacion: "",
          propietario: "",
          ruc: "",
          situacion: "",
          vencimiento: "",
          capacidadCarga: "",
          peso: "",
          fotos: [],
        }}
        validationSchema={checkoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <DinatranAutoLookupWatcher
              onTrigger={handleConsultarDinatran}
              onSchedule={handleAutoSchedule}
              onCancel={handleAutoCancel}
              lastLookupRef={lastLookupRef}
            />
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
              }}
            >
              <TextField
                fullWidth
                select
                variant="filled"
                label="País de origen"
                name="country"
                value={values.country || ""}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.country && !!errors.country}
                helperText={touched.country && errors.country}
                sx={{ gridColumn: "span 1" }}
              >
                {COUNTRY_OPTIONS.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Chapa"
                onBlur={handleBlur}
                onChange={(event) => {
                  const upperValue = event.target.value.toUpperCase();
                  setFieldValue("chapa", upperValue);
                }}
                value={values.chapa || ""}
                name="chapa"
                error={!!touched.chapa && !!errors.chapa}
                helperText={touched.chapa && errors.chapa}
                sx={{ gridColumn: "span 1" }}
                InputProps={{
                  endAdornment:
                    isAutoLookupScheduled || isDinatranLoading ? (
                      <InputAdornment position="end">
                        <CircularProgress size={18} sx={{ color: "#cedc00" }} />
                      </InputAdornment>
                    ) : null,
                }}
                onClick={() => setClasificacionModalOpen(true)}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Marca"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.brand || ""}
                name="brand"
                error={!!touched.brand && !!errors.brand}
                helperText={touched.brand && errors.brand}
                sx={{ gridColumn: "span 1" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Modelo"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.model || ""}
                name="model"
                error={!!touched.model && !!errors.model}
                helperText={touched.model && errors.model}
                sx={{ gridColumn: "span 1" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Chasis"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.chasis || ""}
                name="chasis"
                error={!!touched.chasis && !!errors.chasis}
                helperText={touched.chasis && errors.chasis}
                sx={{ gridColumn: "span 1" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Año"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.year || ""}
                name="year"
                error={!!touched.year && !!errors.year}
                helperText={touched.year && errors.year}
                sx={{ gridColumn: "span 1" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Ejes"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.axes || ""}
                name="axes"
                error={!!touched.axes && !!errors.axes}
                helperText={touched.axes && errors.axes}
                sx={{ gridColumn: "span 1" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Nro. Habilitación"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.nroHabilitacion || ""}
                name="nroHabilitacion"
                error={!!touched.nroHabilitacion && !!errors.nroHabilitacion}
                helperText={touched.nroHabilitacion && errors.nroHabilitacion}
                sx={{ gridColumn: "span 1" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Propietario"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.propietario || ""}
                name="propietario"
                error={!!touched.propietario && !!errors.propietario}
                helperText={touched.propietario && errors.propietario}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="RUC"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.ruc || ""}
                name="ruc"
                error={!!touched.ruc && !!errors.ruc}
                helperText={touched.ruc && errors.ruc}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Situación"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.situacion || ""}
                name="situacion"
                error={!!touched.situacion && !!errors.situacion}
                helperText={touched.situacion && errors.situacion}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Vencimiento"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.vencimiento || ""}
                name="vencimiento"
                error={!!touched.vencimiento && !!errors.vencimiento}
                helperText={touched.vencimiento && errors.vencimiento}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Capacidad de carga"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.peso || ""}
                name="capacidadCarga"
                error={!!touched.capacidadCarga && !!errors.capacidadCarga}
                helperText={touched.capacidadCarga && errors.capacidadCarga}
                sx={{ gridColumn: "span 2" }}
              />
              {/* <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Peso"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.peso || ""}
                name="peso"
                error={!!touched.peso && !!errors.peso}
                helperText={touched.peso && errors.peso}
                sx={{ gridColumn: "span 2" }}
              /> */}
              {/* Otros campos */}
            </Box>
            <Box display="flex" justifyContent="end" mt="20px">
              {/* <Button
                type="button"
                color="secondary"
                variant="contained"
                sx={{ marginRight:"20px" }}
                onClick={() => handleConsultarDinatran(values, setFieldValue)}
              >
                Consultar Dinatran
              </Button> */}
              <Button type="button" color="secondary" variant="contained" sx={{marginRight:"20px"}} onClick={() => setIsModalCamionOpen(true)}>
                Consultar
              </Button>
              <Button type="submit" color="secondary" variant="contained">
                Registrar
              </Button>

            </Box>
            {vehiclePhotos.length > 0 && (
              <Box mt="30px">
                <Typography variant="h6" gutterBottom>
                  Fotos del vehículo
                </Typography>
                <Box
                  display="grid"
                  gap="16px"
                  gridTemplateColumns="repeat(auto-fill, minmax(220px, 1fr))"
                >
                  {vehiclePhotos.map((url, index) => (
                    <Box
                      key={url || index}
                      borderRadius="8px"
                      overflow="hidden"
                      boxShadow={1}
                      bgcolor="background.paper"
                      sx={{ cursor: "pointer" }}
                      onClick={() => handleOpenPhotoPreview(index)}
                    >
                      <Box
                        component="img"
                        src={url}
                        alt={`Foto ${index + 1} del vehículo`}
                        width="100%"
                        height="220px"
                        sx={{ objectFit: "cover" }}
                      />
                    </Box>
                  ))}
                </Box>
              </Box>
            )}
          </form>
        )}
      </Formik>
      <ModalCamion
        open={isModalCamionOpen}
        onClose={() => setIsModalCamionOpen(false)}
        onSelectVehiculos={handleSelectCamion}
      /> 
      <Dialog
        open={isPhotoPreviewOpen}
        onClose={handleClosePhotoPreview}
        maxWidth={false}
        PaperProps={{
          sx: {
            backgroundColor: "transparent",
            boxShadow: "none",
            overflow: "visible",
          },
        }}
        BackdropProps={{ sx: { backgroundColor: "rgba(0,0,0,0.9)" } }}
      >
        {vehiclePhotos.length > 0 && (
          <Box
            position="relative"
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{
              width: "40vw",
              height: "70vh",
              padding: { xs: "1px", md: "1px" },
            }}
          >
            <IconButton
              aria-label="Cerrar"
              onClick={handleClosePhotoPreview}
              sx={{ position: "absolute", top: 16, right: 16, color: "#fff", zIndex: 2 }}
            >
              <CloseIcon />
            </IconButton>
            {vehiclePhotos.length > 1 && (
              <IconButton
                aria-label="Foto anterior"
                onClick={showPreviousPhoto}
                sx={{ position: "absolute", left: 16, color: "#fff", zIndex: 2 }}
              >
                <ArrowBackIosNewIcon />
              </IconButton>
            )}
            <Box
              component="img"
              src={vehiclePhotos[photoPreviewIndex]}
              alt={`Foto ampliada ${photoPreviewIndex + 1} del vehículo`}
              sx={{
                maxWidth: "95vw",
                maxHeight: "95vh",
                width: "80%",
                height: "80%",
                objectFit: "contain",
                borderRadius: 2,
                boxShadow: 6,
              }}
            />
            {vehiclePhotos.length > 1 && (
              <IconButton
                aria-label="Foto siguiente"
                onClick={showNextPhoto}
                sx={{ position: "absolute", right: 16, color: "#fff", zIndex: 2 }}
              >
                <ArrowForwardIosIcon />
              </IconButton>
            )}
          </Box>
        )}
      </Dialog>
    </Box>
  );
};

const checkoutSchema = yup.object().shape({
  brand: yup.string().required("Marca del Vehiculo requerida"),
  model: yup.string().required("Modelo del Vehiculo requerida"),
  chapa: yup.string().required("Chapa requerida"), // Agrega validación si es necesario
  country: yup.string().oneOf(COUNTRY_OPTIONS.map((option) => option.value)).required("País de origen requerido"),
  chasis: yup.string(),
  year: yup.string(),
  axes: yup.string(),
  nroHabilitacion: yup.string(),
  propietario: yup.string(),
  ruc: yup.string(),
  situacion: yup.string(),
  vencimiento: yup.string(),
  capacidadCarga: yup.string(),
  peso: yup.string(),
});

export default Vehiculo;

const DinatranAutoLookupWatcher = ({ onTrigger, onSchedule, onCancel, lastLookupRef }) => {
  const { values, setFieldValue } = useFormikContext();
  const timerRef = useRef(null);

  useEffect(() => {
    const chapaInput = values.chapa ? values.chapa.trim() : "";
    const normalizedChapa = chapaInput.toUpperCase();
    const selectedCountry = values.country || "";

    if (normalizedChapa.length > 5 && selectedCountry) {
      const alreadyFetched =
        normalizedChapa === lastLookupRef.current.chapa &&
        selectedCountry === lastLookupRef.current.country;

      if (alreadyFetched) {
        onCancel();
        return;
      }

      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }

      onSchedule();
      const payload = {
        chapa: normalizedChapa,
        country: selectedCountry,
        brand: values.brand,
        model: values.model,
      };

      timerRef.current = setTimeout(() => {
        onTrigger(payload, setFieldValue);
        timerRef.current = null;
      }, 1000);
    } else {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
      onCancel();
    }

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [values.chapa, values.country, values.brand, values.model, onTrigger, onSchedule, onCancel, setFieldValue, lastLookupRef]);

  return null;
};